import actionTypes from "../../redux/actionTypes";
import { ActionCreator, Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../../redux/initialState";
import ContentfulService from "../../services/contentfulService";
import ContentType from "../../services/contentTypes";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WelcomeContent } from "./welcomeContentTypes";

export type AppThunk = ActionCreator<ThunkAction<void, ApplicationState, WelcomeContent, Action<string>>>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchWelcomeContent: ActionCreator<ThunkAction<void, ApplicationState, any, Action<string>>> = () => {
  let slug = window.location.pathname.split("/")[1].toLowerCase();
  if (!slug) {
    slug = "tal";
  }
  return async (dispatch: Dispatch): Promise<Action<any>> => {
    try {
      const contentfulService = new ContentfulService();
      const entries: any = await contentfulService.getContentTypeFilterBySlugTheme(ContentType.WELCOME_CONTENT, slug);

      // eslint-disable-next-line prefer-const
      let welcomeContent: WelcomeContent = { id: "", welcomeTitle: "", welcomeDescription: "", welcomeDescription2: "" };
      if (entries?.items?.length > 0) {
        const item: any = entries.items[0];
        welcomeContent.id = item.sys.id;
        welcomeContent.welcomeTitle = item.fields.welcomeTitle;
        welcomeContent.welcomeDescription = item.fields.welcomeDescription;
        welcomeContent.welcomeDescription2 = item.fields.welcomeDescription2;
      }
      return dispatch({
        type: actionTypes.LOAD_WELCOME_CONTENT_SUCCESS,
        payload: welcomeContent,
      });
    } catch (e) {
      console.log("ERROR");
      return dispatch({
        type: actionTypes.LOAD_WELCOME_CONTENT_ERROR,
        payload: e,
      });
    }
  };
};
